module.exports = __webpack_public_path__ + "assets/img/fanganweinzi03.b391f994.png";